import {
  AppCard,
  Icon,
  PageContainer,
} from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import {
  mdiFileDocumentMultipleOutline,
  mdiFileDocumentOutline,
} from "@mdi/js";
import { Box, Divider, Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ForbiddenError } from "../../../errors/ForbiddenError";
import { useAuth } from "../../../hooks/useAuth";
import { MultipleRequestForm } from "./-internal_components/MultipleRequestForm";
import { SingleRequestForm } from "./-internal_components/SingleRequestForm";

const NewDeliveryDateChangeRequest: React.FC = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  return (
    <PageContainer
      showBackButton
      title={t("deliveryDateChangeRequests.titles.new")}
    >
      {user?.roles_names.includes(
        "Delivery Date Change Request - Create In Mass",
      ) && (
        <>
          <AppCard
            icon={<Icon icon={mdiFileDocumentMultipleOutline} />}
            subtitle={t(
              "deliveryDateChangeRequests.titles.massRequestSubtitle",
            )}
            title={t("deliveryDateChangeRequests.titles.massRequest")}
          >
            <MultipleRequestForm />
          </AppCard>
          <Box>
            <Divider
              sx={{
                alignItems: "center",
                display: "flex",
                margin: "24px 0 16px 0",
              }}
            >
              <Typography
                sx={{
                  color: "text.secondary",
                  fontWeight: "bold",
                }}
                variant="body1"
              >
                {t("common.or").toUpperCase()}
              </Typography>
            </Divider>
          </Box>
        </>
      )}
      <AppCard
        icon={<Icon icon={mdiFileDocumentOutline} />}
        subtitle={t("deliveryDateChangeRequests.titles.singleRequestSubtitle")}
        title={t("deliveryDateChangeRequests.titles.singleRequest")}
      >
        <SingleRequestForm />
      </AppCard>
    </PageContainer>
  );
};

export const Route = createFileRoute(
  "/_private/delivery_date_change_requests/new",
)({
  beforeLoad({ context }) {
    if (
      context.auth.user?.roles_names.includes(
        "Delivery Date Change Request - Create",
      )
    ) {
      return;
    }

    throw new ForbiddenError();
  },
  component: NewDeliveryDateChangeRequest,
});
